import { useParams } from "react-router-dom";
import { IncidentWorkflow } from "@/components/incidents/IncidentWorkflow";

export default function EditIncident() {
  const { id } = useParams();
  return <IncidentWorkflow key={id} incidentId={id} />;
}